<template>
  <el-date-picker
    :model-value="modelValue"
    type="datetime"
    value-format="YYYY-MM-DD HH:mm:ss"
    format="YYYY年MM月DD日 HH:mm:ss"
    :placeholder="placeholder"
    style="width: 100%;"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  modelValue?: string
  placeholder?: string
}>(), {
  modelValue: '',
  placeholder: '请选择时间',
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>
